import {useOktaAuth} from "@okta/okta-react";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Routes} from "../../../common/Routes";
import {isNullOrUndefined} from "../../../common/utils";
import {createConditionTree} from "../../../components/condition/utils/createConditionTree";
import {findKeyConditionById} from "../../../components/condition/utils/findKeyConditionById";
import {findListOfKeyConditions} from "../../../components/condition/utils/findListOfKeyConditions";
import {useVerifyUserGroupType} from "../hooks/VerifyUserGroupType";
import {UserGroupActions} from "../model";
import {MemberInfoListActions} from "./model";
import {useHandleInvalidUserGroup} from "../hooks/HandleInvalidUserGroup";

export const PreviewKeyConditionController = (
  userGroupUniqueName,
  userGroupTypeUniqueName,
  conditionId,
  page,
  size
) => {
  const {authState} = useOktaAuth();
  const history = useHistory();
  const dispatch = useDispatch();
  const userGroupDetails = useSelector(
    (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.value
  );

  const isUserExcluded = (user) => Boolean(userGroupDetails
    && userGroupDetails.excludedMembers.find((excludedMember) => excludedMember.userId === user.key))

  const rowClassNameFn = (user) => isUserExcluded(user) ? "member-excluded" : "";

  useVerifyUserGroupType(userGroupTypeUniqueName);
  useHandleInvalidUserGroup(userGroupUniqueName)

  const {
    value: {data, totalPages, totalElements},
    progress,
  } = useSelector(
    (rootState) => rootState.membersMatchingConditionList.membersMatchingConditionList
  );
  let columns = useSelector((rootState) => rootState.membersMatchingConditionList.columns);

  function backClick() {
    history.push(`${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}/${userGroupUniqueName}`);
  }

  useEffect(() => {
    if (isNullOrUndefined(userGroupDetails)) {
      dispatch(UserGroupActions.getUserGroupDetails(userGroupUniqueName));
    }
  }, [userGroupUniqueName]);

  const membershipConditionsTree = createConditionTree(userGroupDetails?.membershipCondition, null);

  const listOfKeyConditions = [];
  const keyConditions = [];
  findListOfKeyConditions(membershipConditionsTree, listOfKeyConditions);
  findKeyConditionById(listOfKeyConditions, keyConditions, conditionId);

  const condition = keyConditions[0];
  useEffect(() => {
    if (authState.isAuthenticated && !isNullOrUndefined(condition)) {
      dispatch(
        MemberInfoListActions.getMemberInfoList({
          page: page,
          size: size,
          condition: condition.toJSON(),
        })
      );
    }
  }, [page, size, condition?.key]);

  return {
    keyCondition: keyConditions,
    backClick,
    data,
    columns,
    totalPages,
    totalElements,
    isLoading: !!progress,
    rowClassNameFn,
  };
};
